import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Tag from '../../../components/Tag'
import { RootState } from "../../../redux/store";
import { setSignupData } from '../../../redux/signup';
import { GAEventNames, GACategoryName, GAUniqueEventIds } from "../../../helpers/Enums";
import { recordGaEvent } from "../../../helpers/GoogleAnalytics";

const PersonalStatusQuestion = (props: any) => {
    const dispatch = useDispatch();
    const register = useSelector((state: RootState) => state.signup);
    const question = useSelector((state: RootState) => state.signupQuestions.questions?.filter(x => x.questionId === 15));
    const [selectedTag, setSelectedTag] = useState(register.personalStatusId);


    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        register.personalStatusId = selectedTag;
        dispatch(setSignupData(register));
        props.next();

        recordGaEvent(GAEventNames.APP_SIGNUP, GACategoryName.SIGNING_STEPS, "step 10", "אישור סטטוס זוגי", GAUniqueEventIds.APP_SIGNUP)

    };

    const enabled = selectedTag !== -1;
    return (
        <>
            <div className="content_sec wf-section" style={{ paddingBottom: '100px' }}>

                <div className="signup_top_info">
                    <div className="icon_info"><img src="~/assets/images/ic_info_smoke.svg" loading="lazy" alt="" /></div>
                    <h2 className="signup_title">{question && question[0].question}</h2>
                    <div>{question && question[0].questionSubTitle}</div>
                </div>
                <div className="login_sec w-form">
                    <form onSubmit={handleSubmit}>
                        <div className="form_field_content login">
                            <div className="form_links_group signup">
                                {
                                    question && question[0].tags?.map((tag, key) => {
                                        const { text, value } = tag;
                                        const isSelected = selectedTag === value;
                                        const onPress = () => setSelectedTag(value);
                                        return (
                                            <Tag {...{ text, key, onPress, isSelected }} />
                                        )

                                    })
                                }
                            </div>
                        </div>
                        <div className="form_send_group">
                            <div className="form_buttons_group signup">
                                <input autoComplete="off" disabled={!enabled} type="submit" value="אפשר להמשיך" data-wait="" className={`button w-button ${enabled ? "button_full w-button" : "button_full inactive  w-button"}`} />
                            </div>
                        </div>

                        {/* <div class="form_send_group">
                            <div class="form_buttons_group signup">
                                <input type="submit" value="טקסט דינמי" data-wait="" class="button w-button">

                            </div>
                        </div> */}

                    </form>

                </div>
            </div>

        </>
    )
}

export default PersonalStatusQuestion;